module.exports = __webpack_public_path__ + "img/CS48Q-中_15.5ccdb96b.jpg";